import { createContext } from "react";

import Login from "components/Auth/Login";
import PasswordRegistrar from "components/Auth/PasswordRegistrar";
import MfaCodeSender from "components/Auth/MfaCodeSender";
import { useAuth } from "components/Auth/useAuth";
export const AuthContext = createContext(null);

const Auth = ({ children }) => {
  const auth = useAuth();
  const { loginState, loginError, completeNewPassword, sendMFACode, login } = auth;

  // render
  // ログイン済みの場合は下層の要素をそのまま描画
  if (auth && auth.user && children) {
    return (
      <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
    );
  }
  switch (loginState) {
    case "newPasswordRequired":
    // 本パスワード設定の場合は本パスワード設定ビューを描画
      return <PasswordRegistrar submit={completeNewPassword} error={loginError} />;
    case "totpRequired":
      return <MfaCodeSender submit={sendMFACode} error={loginError} />;
    default:
      // no default
      break;
  }
  return <Login submit={login} error={loginError} />;
};

export default Auth;
